import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "d-flex w-100" }
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_10 = { class: "mt-2" }
const _hoisted_11 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_12 = { class: "container-fluid" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = { class: "col-6" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-sm-12 col-md-auto mb-2" }
const _hoisted_19 = { class: "col-sm-12 col-md-auto mb-2" }
const _hoisted_20 = { class: "col-sm-12 col-md-auto mb-2" }
const _hoisted_21 = { clas: "row" }
const _hoisted_22 = { class: "col" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "card-body" }
const _hoisted_26 = { class: "card-footer" }
const _hoisted_27 = {
  key: 1,
  class: "table table-striped"
}
const _hoisted_28 = { style: {"min-width":"100px"} }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("th", null, null, -1)

import { getEntityTranslation, isMobileReactive } from "@/helpers";
import provideCompanyFormInfo from "@/types/symbols/provideCompanyFormInfo";
import { AlertManager, NotificationManager } from "@hakosalo/hakolib";
import { inject, nextTick, onMounted, ref, watch } from "vue";
import FormSection from "../FormSection.vue";
import CompanyFormFields from "./CompanyFormFields.vue";

import publicFormApi from "@/publicFormApi";
import { DraftCompanyFormDataDto } from "@api/draft-company-form-data-dto";
import { ValidationFailureDto } from "@api/validation-failure-dto";
import { cloneDeep, values } from "lodash";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import FormSectionHeader from "../FormSectionHeader.vue";

import { useLiveValidation, useValidation } from "@/composables/fields";
import { dbEnums } from "@/types/enums/dbEnums";
import { Field } from "@/types/interfaces/field";
import { NetboxCompany } from "@api/netbox-company";
import { NetboxCompanyShort } from "@api/netbox-company-short";
import { flatten, keyBy, take } from "lodash";

interface PrivacyPolicyAccepts {
	[key: number]: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyForm',
  emits: ["saveSuccess", "saveFailed"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const makeHttps = (url: string) => {
	url = url.indexOf("://") === -1 ? "https://" + url : url;
	return url;
};

const blankDraft = ref<DraftCompanyFormDataDto | null>(null);

const resetFormData = () => {
	formData.value = cloneDeep(blankDraft.value);
};

onMounted(() => {
	publicFormApi.call.companyForm.get.getDraft().then((r) => {
		if (r.isSuccessful) {
			formData.value = r.data;
			blankDraft.value = cloneDeep(r.data);
		}
	});
});

const isSaving = ref(false);

const formDataComputed = computed({
	get() {
		return formData.value;
	},
	set(v) {
		formData.value = v;
	},
});

// Inject validation system
const { validationErrors, validationStateMap } = useValidation<DraftCompanyFormDataDto | null>();

const validationEndpoint = publicFormApi.call.validation.post.validateCompanyProperties;

useLiveValidation<DraftCompanyFormDataDto | null>(
	validationEndpoint,
	formDataComputed,
	validationErrors,
	validationStateMap
);

const save = () => {
	if (!formData.value) {
		return;
	}
	isSaving.value = true;
	publicFormApi.call.companyForm.post
		.default(formData.value)
		.then(async (r) => {
			if (r.isSuccessful && r.data) {
				emit("saveSuccess");
				return;
			} else if (r.isHandledFailure && r.error && r.error.codeName == "ValidationError") {
				await AlertManager.alert(t("generic.checkFields"), t("generic.fixInvalidInputs"));

				validationErrors.value =
					(r.error.data as ValidationFailureDto[]) || ([] as ValidationFailureDto[]);

				nextTick(() => {
					// from dom search all elements with class invalid-feedback that have display:block
					const invalidFeedbacks = Array.from(document.querySelectorAll(".invalid-feedback"));

					// Filter elements that have display:block
					const visibleInvalidFeedbacks = invalidFeedbacks.filter(
						(el) => window.getComputedStyle(el).display === "block"
					);

					if (visibleInvalidFeedbacks.length > 0) {
						// Select parent of the first element
						const parent = visibleInvalidFeedbacks[0].parentElement;

						if (parent) {
							// Select first input inside the parent
							const input = parent.querySelector("input");

							if (input) {
								// Scroll to the first input
								input.scrollIntoView({ block: "center" });
								input.focus();
							}
						}
					}
				});
				return;
			}
			emit("saveFailed");
		})
		.finally(() => {
			isSaving.value = false;
		});
};

const clear = async () => {
	try {
		await AlertManager.confirm(t("generic.warning"), t("generic.clearAreYouSure"));
		resetFormData();
	} catch {
		// Too bad
	}
};

const formData = ref<DraftCompanyFormDataDto | null>(null);

const formInfo = inject(provideCompanyFormInfo);

const privacyPolicyAccepts = ref<PrivacyPolicyAccepts>({});

const privacyPolicies = computed(() => {
	if (!formInfo || !formInfo.value) {
		return [];
	}
	return formInfo.value.publicForm.privacyPolicies;
});

watch(
	privacyPolicies,
	() => {
		privacyPolicyAccepts.value = {};
		privacyPolicies.value.forEach((pp) => {
			privacyPolicyAccepts.value[pp.id] = false;
		});
	},
	{ immediate: true }
);

const enabledFields = computed(() => {
	let fields: Field[] = [];
	if (!formInfo || !formInfo.value) {
		return fields;
	}

	fields = flatten(formInfo.value.fieldCategories.map((r) => r.fields));
	return fields;
});

const isEnabled = (fieldId: string) => {
	if (enabledFields.value.some((r) => r.id == fieldId)) {
		return true;
	}
	return false;
};

const allowSave = computed(() => {
	if (!formData.value) {
		return false;
	}

	if (!formData.value.acceptDataSaving) {
		return false;
	}

	if (values(formData.value.privacyPolicyConfirms).some((r) => r == false)) {
		return false;
	}

	return true;
});

// netbox stuff

const netboxModalOpen = ref(false);
const netboxLoading = ref(false);
const netboxName = ref("");
const netboxShortResults = ref<NetboxCompanyShort[]>([]);
const netboxBusinessId = ref("");
const netboxResult = ref<NetboxCompany | null>(null);

const modalSearch = ref("");
const modalShowAmount = ref(15);

const netboxShortResultsComputed = computed(() => {
	return take(
		netboxShortResults.value.filter(
			(r) => r.name.toLocaleLowerCase().indexOf(modalSearch.value.toLocaleLowerCase()) >= 0
		),
		modalShowAmount.value
	);
});

const showLess = () => {
	modalShowAmount.value = 15;
};

const showMore = () => {
	modalShowAmount.value += 15;
};

const showAll = () => {
	modalShowAmount.value = netboxShortResults.value.length;
};

const fillCompany = (businessId: string) => {
	netboxModalOpen.value = false;
	netboxBusinessId.value = businessId;
	validationErrors.value = [];
	searchNetbox();
};

const searchNetbox = () => {
	if (netboxBusinessId.value) {
		netboxLoading.value = true;
		publicFormApi.call.companyForm.get
			.netboxSearchByBusinessId(netboxBusinessId.value)
			.then((r) => {
				if (r.isSuccessful && r.data) {
					netboxResult.value = r.data;
					fillFromNetboxCompany(r.data);
				}
			});
	} else if (netboxName.value) {
		netboxShortResults.value = [];
		netboxModalOpen.value = true;
		netboxLoading.value = true;
		publicFormApi.call.companyForm.get
			.netboxSearchByName(netboxName.value)
			.then((r) => {
				if (r.isSuccessful && r.data) {
					netboxShortResults.value = r.data;
				}
			})
			.finally(() => (netboxLoading.value = false));
	}
};

const fillFromNetboxCompany = async (netboxCompany: NetboxCompany) => {
	if (!formData.value) {
		return;
	}
	resetFormData();
	await nextTick();
	netboxLoading.value = true;
	formData.value.draftCompanyData.businessId = netboxCompany.vat_identifier;
	formData.value.draftCompanyData.name =
		netboxCompany.names.filter((r) => r.type == "primary").shift()?.name || "";

	if (netboxCompany.domicile && isEnabled(dbEnums.CompanyFields.HomeMunicipality)) {
		try {
			const municipalityResp = await publicFormApi.call.form.get.municipality(
				netboxCompany.domicile
			);
			if (municipalityResp.isSuccessful && municipalityResp.data) {
				formData.value.draftCompanyData.homeMunicipalityId = municipalityResp.data.code;
				formData.value.draftCompanyData.homeMunicipality = municipalityResp.data;
			}
		} catch (error) {
			console.error(error);
		}
	}

	const contactMap = keyBy(netboxCompany.contact, "code");

	if (contactMap.sms?.value && isEnabled(dbEnums.CompanyFields.Phone)) {
		formData.value.draftCompanyData.phone = contactMap.sms.value;
	}
	if (contactMap.phone?.value && isEnabled(dbEnums.CompanyFields.Phone)) {
		formData.value.draftCompanyData.phone = contactMap.phone.value;
	}
	if (contactMap.www?.value && isEnabled(dbEnums.CompanyFields.Website)) {
		formData.value.draftCompanyData.website = contactMap.www.value;
	}
	if (contactMap.email?.value && isEnabled(dbEnums.CompanyFields.Email)) {
		formData.value.draftCompanyData.email = contactMap.email.value;
	}

	const addressMap = keyBy(netboxCompany.addresses, "type");

	if (addressMap.visiting?.street && isEnabled(dbEnums.CompanyFields.VisitingAddress)) {
		formData.value.draftCompanyData.visitingAddress!.streetAddress = addressMap.visiting.street;
	}
	if (addressMap.visiting?.zipcode && isEnabled(dbEnums.CompanyFields.VisitingAddress)) {
		try {
			const visitingAddressResp = await publicFormApi.call.form.get.postalCode(
				addressMap.visiting.zipcode
			);
			if (visitingAddressResp.isSuccessful && visitingAddressResp.data) {
				formData.value.draftCompanyData.visitingAddress!.postalCodeId =
					visitingAddressResp.data.id;
				formData.value.draftCompanyData.visitingAddress!.postalCode = visitingAddressResp.data;
				formData.value.draftCompanyData.visitingAddress!.municipalityId =
					visitingAddressResp.data.municipalityId;
				formData.value.draftCompanyData.visitingAddress!.municipality =
					visitingAddressResp.data.municipality!;
			}
		} catch (error) {
			console.error(error);
		}
	}
	if (addressMap.postal?.street && isEnabled(dbEnums.CompanyFields.PostalAddress)) {
		formData.value.draftCompanyData.postalAddress!.streetAddress = addressMap.postal.street;
	}
	if (addressMap.postal?.zipcode && isEnabled(dbEnums.CompanyFields.PostalAddress)) {
		try {
			const postalCodeResp = await publicFormApi.call.form.get.postalCode(
				addressMap.postal.zipcode
			);
			if (postalCodeResp.isSuccessful && postalCodeResp.data) {
				formData.value.draftCompanyData.postalAddress!.postalCodeId = postalCodeResp.data.id;
				formData.value.draftCompanyData.postalAddress!.postalCode = postalCodeResp.data;
				formData.value.draftCompanyData.postalAddress!.municipalityId =
					postalCodeResp.data.municipalityId;
				formData.value.draftCompanyData.postalAddress!.municipality =
					postalCodeResp.data.municipality!;
			}
		} catch (error) {
			console.error(error);
		}
	}
	if (netboxCompany.type?.name && isEnabled(dbEnums.CompanyFields.Type)) {
		try {
			const formResp = await publicFormApi.call.companyForm.get.matchNetboxCompanyForm(
				netboxCompany.type.name
			);
			if (formResp.isSuccessful && formResp.data) {
				formData.value.draftCompanyData.companyFormId = formResp.data.id;
				formData.value.draftCompanyData.companyForm = formResp.data;
			}
		} catch (error) {
			console.error(error);
		}
	}
	if (netboxCompany.language?.code && isEnabled(dbEnums.CompanyFields.Language)) {
		try {
			const formResp = await publicFormApi.call.companyForm.get.matchNetboxLanguage(
				netboxCompany.language.code
			);
			if (formResp.isSuccessful && formResp.data) {
				formData.value.draftCompanyData.languageId = formResp.data.code;
				formData.value.draftCompanyData.language = formResp.data;
			}
		} catch (error) {
			console.error(error);
		}
	}
	if (netboxCompany.industry && isEnabled(dbEnums.CompanyFields.TOL2008)) {
		const maxLevelTol = netboxCompany.industry.reduce(function (prev, current) {
			return prev && prev.level > current.level ? prev : current;
		});
		if (maxLevelTol) {
			try {
				const formResp = await publicFormApi.call.companyForm.get.matchNetboxTol(
					maxLevelTol.code
				);
				if (formResp.isSuccessful && formResp.data) {
					formData.value.draftCompanyData.tol2008Id = formResp.data.id;
					formData.value.draftCompanyData.tol2008 = formResp.data;
				}
			} catch (error) {
				console.error(error);
			}
		}
	}

	netboxLoading.value = false;

	NotificationManager.quickSuccess(
		t("companyForm.sectionNetbox.fillSuccess"),
		t("companyForm.sectionNetbox.fillSuccessTxt")
	);
};

return (_ctx: any,_cache: any) => {
  const _component_HakoInput = _resolveComponent("HakoInput")!
  const _component_HakoLabelControl = _resolveComponent("HakoLabelControl")!
  const _component_HakoButton = _resolveComponent("HakoButton")!
  const _component_HakoSpinner = _resolveComponent("HakoSpinner")!
  const _component_HakoBsIcon = _resolveComponent("HakoBsIcon")!
  const _component_HakoCheckbox = _resolveComponent("HakoCheckbox")!
  const _component_HakoModal = _resolveComponent("HakoModal")!
  const _component_HakoFullscreenSpinner = _resolveComponent("HakoFullscreenSpinner")!

  return (_unref(formInfo) && formData.value && formData.value.draftCompanyData)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(FormSection, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(FormSectionHeader, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("companyForm.sectionNetbox.header")), 1)
                ]),
                _: 1
              }),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("companyForm.sectionNetbox.searchParagraph")), 1),
              _createVNode(_component_HakoLabelControl, {
                block: "",
                label: _ctx.$t('companyForm.sectionNetbox.businessIdLabel'),
                for: "netboxBusinessId",
                class: "form-field-label"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_HakoInput, {
                    id: "netboxBusinessId",
                    modelValue: netboxBusinessId.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((netboxBusinessId).value = $event)),
                    style: {"max-width":"250px"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_HakoLabelControl, {
                block: "",
                label: _ctx.$t('companyForm.sectionNetbox.nameLabel'),
                for: "netboxName",
                class: "form-field-label"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_HakoInput, {
                    id: "netboxName",
                    modelValue: netboxName.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((netboxName).value = $event)),
                    style: {"max-width":"500px"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_HakoButton, {
                onClick: _withModifiers(searchNetbox, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("generic.search")), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        (netboxLoading.value)
          ? (_openBlock(), _createBlock(_component_HakoSpinner, { key: 0 }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(CompanyFormFields, {
                modelValue: formData.value.draftCompanyData,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.draftCompanyData) = $event)),
                contactReasonOptions: formData.value.contactReasonOptions
              }, null, 8, ["modelValue", "contactReasonOptions"]),
              _createVNode(FormSection, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(FormSectionHeader, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("generic.sectionPrivacy")), 1)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(privacyPolicies.value, (pp) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: pp.id,
                            class: "my-3"
                          }, [
                            _createElementVNode("div", _hoisted_6, [
                              _createVNode(_component_HakoCheckbox, {
                                modelValue: formData.value.privacyPolicyConfirms[pp.id],
                                "onUpdate:modelValue": ($event: any) => ((formData.value.privacyPolicyConfirms[pp.id]) = $event)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("generic.haveReadAndAccept")) + " ", 1),
                                  _createElementVNode("a", {
                                    class: "mx-3",
                                    href: makeHttps(pp.url),
                                    target: "_blank"
                                  }, [
                                    _createTextVNode(_toDisplayString(_unref(getEntityTranslation)(pp.translations, "name")) + " ", 1),
                                    _createVNode(_component_HakoBsIcon, {
                                      icon: "box-arrow-up-right",
                                      size: 90
                                    })
                                  ], 8, _hoisted_7),
                                  (!formData.value.privacyPolicyConfirms[pp.id])
                                    ? (_openBlock(), _createElementBlock("small", _hoisted_8, _toDisplayString(_ctx.$t("generic.required")), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue"])
                            ])
                          ]))
                        }), 128)),
                        _hoisted_9,
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_HakoCheckbox, {
                            modelValue: formData.value.acceptDataSaving,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.acceptDataSaving) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(getEntityTranslation)(
											_unref(formInfo).publicForm.translations,
											"acceptSaveData"
										)) + " ", 1),
                              (!formData.value.acceptDataSaving)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_11, _toDisplayString(_ctx.$t("generic.required")), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_HakoButton, {
                      onClick: save,
                      disabled: !allowSave.value,
                      isBlock: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("generic.send")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_HakoButton, {
                      onClick: clear,
                      isBlock: "",
                      theme: "danger"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("generic.clear")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ], 64)),
        _createVNode(_component_HakoModal, {
          modelValue: netboxModalOpen.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((netboxModalOpen).value = $event)),
          size: "md"
        }, {
          default: _withCtx(() => [
            (netboxLoading.value)
              ? (_openBlock(), _createBlock(_component_HakoSpinner, { key: 0 }))
              : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_HakoButton, {
                        sm: "",
                        onClick: showMore,
                        isBlock: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("generic.showMore")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_HakoButton, {
                        sm: "",
                        onClick: showAll,
                        isBlock: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("generic.showAll")) + " (" + _toDisplayString(netboxShortResults.value.length) + " kpl)", 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_HakoButton, {
                        class: "col col-auto",
                        sm: "",
                        onClick: showLess,
                        isBlock: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("generic.showLess")), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_HakoInput, {
                        modelValue: modalSearch.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((modalSearch).value = $event)),
                        placeholder: _ctx.$t('generic.typeToSearch')
                      }, null, 8, ["modelValue", "placeholder"])
                    ])
                  ]),
                  _hoisted_23,
                  (_unref(isMobileReactive))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(netboxShortResultsComputed.value, (r) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "card mb-3",
                            key: r.vat_identifier
                          }, [
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", null, [
                                _createElementVNode("strong", null, _toDisplayString(_ctx.$t("companyForm.sectionNetbox.nameLabel")) + ": ", 1),
                                _createTextVNode(" " + _toDisplayString(r.name), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _createElementVNode("strong", null, _toDisplayString(_ctx.$t("companyForm.sectionNetbox.businessIdLabel")) + ": ", 1),
                                _createTextVNode(" " + _toDisplayString(r.vat_identifier), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _createElementVNode("strong", null, _toDisplayString(_ctx.$t("companyForm.sectionNetbox.municipalityLabel")) + ": ", 1),
                                _createTextVNode(" " + _toDisplayString(r.domicile), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_HakoButton, {
                                theme: "success",
                                sm: "",
                                onClick: ($event: any) => (fillCompany(r.vat_identifier)),
                                isBlock: ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("generic.select")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (!_unref(isMobileReactive))
                    ? (_openBlock(), _createElementBlock("table", _hoisted_27, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t("companyForm.sectionNetbox.nameLabel")), 1),
                            _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.$t("companyForm.sectionNetbox.businessIdLabel")), 1),
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t("companyForm.sectionNetbox.municipalityLabel")), 1),
                            _hoisted_29
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(netboxShortResultsComputed.value, (r) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: r.vat_identifier
                            }, [
                              _createElementVNode("td", null, _toDisplayString(r.name), 1),
                              _createElementVNode("td", null, _toDisplayString(r.vat_identifier), 1),
                              _createElementVNode("td", null, _toDisplayString(r.domicile), 1),
                              _createElementVNode("td", null, [
                                _createVNode(_component_HakoButton, {
                                  theme: "success",
                                  sm: "",
                                  onClick: ($event: any) => (fillCompany(r.vat_identifier))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("generic.select")), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_HakoFullscreenSpinner, {
          modelValue: netboxLoading.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((netboxLoading).value = $event))
        }, null, 8, ["modelValue"])
      ]))
    : _createCommentVNode("", true)
}
}

})